import store from '../../redux/store';
import { incrementRefreshKey, setSMapData, resetSMapData, setSMapActive } from '../../redux/slices/strategyMapView';
import { StrategyEntityItemType } from '../../services/strategyMap';


export const refreshStrategymapView = () => {
  store.dispatch(incrementRefreshKey());
};

export const setStrategyMapViewData = (
  strategyMapId: string, 
  data: StrategyEntityItemType, 
  scrollToId: string = ""
) => {
  store.dispatch(setSMapData({ strategyMapId, data, scrollToId }));
};
export const setActiveStrategyMap = (
  strategyMapId: string, 
  scrollToId: string = ""
) => {
  store.dispatch(setSMapActive({ strategyMapId, scrollToId }));
};

export const resetStrategyMapView = () => {
  store.dispatch(resetSMapData());
};

